<template>
    <login-layout>
        <form @submit.prevent="doLogin" novalidate>
            <div class="row">
                <div class="col-xs-12" :class="{'has-error': errors['email']}">
                    <input class="custom_input form-control m-b-5" v-model="record.email" type="email" :placeholder="$t('email')" v-pml-focus autocomplete="username">
                    <span class="error" v-if="errors['email']">{{ errors['email'][0] }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12" :class="{'has-error': errors['password']}">
                    <input class="custom_input form-control m-b-5" v-model="record.password" type="password" :placeholder="$t('password')" autocomplete="current-password">
                    <span class="error" v-if="errors['password']">{{ errors['password'][0] }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <button v-pml-block="isLoading" class="btn_login btn btn-block text-uppercase m-t-10" type="submit">{{ $t('login') }}</button>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-offset-6 col-xs-12 col-sm-6 t_right t_sm_center m-t-20">
                    <router-link :to="{ name: 'auth.forgot-password' }" class="link_login">
                        <i class="fa fa-lock m-r-5"></i> {{ $t('forgot_your_password') }}?
                    </router-link>
                </div>
            </div>
        </form>
    </login-layout>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'Login',
        data () {
            return {
                record: {
                    email: null,
                    password: null
                },
                errors: [],
                isLoading: false
            }
        },
        created () {
            this.logout()
        },
        methods: {
            ...mapActions([ 'logout', 'attemptLogin', 'initStore' ]),
            doLogin () {
                this.isLoading = true

                this.attemptLogin(this.record)
                    .then(() => this.fetchData())
                    .catch(error => {
                        this.errors = error.response.data.errors || error.response.data || []
                        this.isLoading = false
                    })
            },
            fetchData () {
                this.initStore()
                    .then(() => {
                        this.$router.push({ name: 'dashboard.index' })
                        this.isLoading = false
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/auth/components/Main.vue